import {
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import {
  ApiBlueprint,
  PageBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { createElement } from 'react';

import { VwtechLibsClient, vwtechLibsApiRef } from './api';
import {
  componentsManagerPageRouteRef,
  landscapeManagerPageRouteRef,
  rootRouteRef,
} from './routes';

const vwtechLibsGlyph = createElement(
  'svg',
  {
    'aria-hidden': 'true',
    viewBox: '0 0 24 24',
    width: 20,
    height: 20,
    fill: 'none',
  },
  createElement('path', {
    d: 'M5.5 7.5h13M8 4.5h8M8 11h8M8 15.5h8M5.5 19.5h13',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round',
  }),
  createElement('rect', {
    x: 4,
    y: 3.5,
    width: 16,
    height: 17,
    rx: 3,
    stroke: 'currentColor',
    strokeWidth: 1.8,
  }),
);

export const vwtechLibsApi = ApiBlueprint.make({
  name: 'service',
  params: defineParams =>
    defineParams({
      api: vwtechLibsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new VwtechLibsClient(discoveryApi, fetchApi),
    }),
});

export const vwtechLibsRootPage = PageBlueprint.make({
  name: 'root',
  params: {
    path: '/vwtech-libs',
    routeRef: rootRouteRef,
    title: 'VWTech Libs',
    icon: vwtechLibsGlyph,
    loader: async () => {
      const { LandingPage } = await import('./components');
      return createElement(LandingPage);
    },
  },
});

export const vwtechLibsComponentsManagerPage = PageBlueprint.make({
  name: 'components-manager',
  params: {
    path: '/vwtech-libs/components-manager',
    routeRef: componentsManagerPageRouteRef,
    title: 'VW Tech Libraries',
    loader: async () => {
      const { LibraryPage } = await import('./components');
      return createElement(LibraryPage);
    },
  },
});

export const vwtechLibsLandscapeManagerPage = PageBlueprint.make({
  name: 'landscape-manager',
  params: {
    path: '/vwtech-libs/landscape-manager',
    routeRef: landscapeManagerPageRouteRef,
    title: 'Landscape Assets',
    loader: async () => {
      const { LandscapeManagerPage } = await import('./components');
      return createElement(LandscapeManagerPage);
    },
  },
});

const alpha = createFrontendPlugin({
  pluginId: 'vwtech-libs',
  routes: {
    root: rootRouteRef,
    componentsManager: componentsManagerPageRouteRef,
    landscapeManager: landscapeManagerPageRouteRef,
  },
  extensions: [
    vwtechLibsApi,
    vwtechLibsRootPage,
    vwtechLibsComponentsManagerPage,
    vwtechLibsLandscapeManagerPage,
  ],
});

export default alpha;
